

import {useChatStore} from '@/stores/chat'

export default defineNuxtPlugin((nuxtApp) => {
    // const chatStore = useChatStore()
    // chatStore.messages = '嘿嘿嘿'
    // const { messages } = storeToRefs(chatStore)
    // const uuid = new Date().getTime()
    // const socket = new WebSocket('ws://192.168.1.43:8080?uuid=' + uuid)
    // socket.onopen = function (e) {
        
    // }
    // socket.onmessage = function (e) {
        
    // }
    // nuxtApp.provide('socket', socket)
    // nuxtApp.provide('messages', messages)
    
})